import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FundHandoverActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/FundHandover/FundHandoverBrowser")
	}

	render() {
		return (
			<Activity 
				name="FundHandover"
				RenderedComponent={this.RenderedComponent}
				context="FundHandover"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FundHandoverActivity)